export default __webpack_public_path__ + "static/media/Ultimate Ears.2e1792a0.svg";